import React, { useState, useEffect, useRef } from "react";
import { Typography } from "@mui/material";
import { useQuery, useMutation, useQueryClient } from "@tanstack/react-query";
import { useParams } from "react-router-dom";
import PropTypes from "prop-types";
import Box from "@mui/material/Box";
import swal from "sweetalert";
import * as api from "../../../actions/api";
import AdjustmentFormData from "./AdjustmentFormData";
import Constants from "../../../services/Constants";
import { useTranslation } from "react-i18next";
import encryptionService from "../../../services/encryptionService";

import { format } from 'date-fns';
const EditAdjustment = (props) => {
  //get DispensingLanguage
  const DispensingLanguage = JSON.parse(
    localStorage.getItem("DispensingLanguage")
  );
  const lan = localStorage.getItem("LangCode");
  const menukey = "adjustment";
  const FacilityId = localStorage.getItem("FacilityId");

  const UserInfo = encryptionService.decryptUserInfo();
  const UserName = UserInfo == 0 ? "" : UserInfo[0].name;

  const { t, i18n } = useTranslation();
  const [formData, setFormData] = useState({
    TransactionDate: "",
    AdjTypeId: "",
    TransactionNo: "",
    FacilityId: FacilityId,
    TransactionId: "",
    IssueToFacility: "",
    PreparedBy: "",
    ApprovedBy: "",
    ItemGroupId: "",
  });
  const [selectedDate, setSelectedDate] = useState(
    //new Date()
    format(new Date(), 'yyyy-MM-dd')
  );
  const handleDateChange = (date) => {
    setSelectedDate(date);
  };
  const [ManyTableData, setManyTableData] = useState([]);
  const [bStockUpdate, setbStockUpdate] = useState("0");
  const [updatedDetailGridData, setUpdatedDetailGridData] = useState([]);
  const [TransactionId, setTransactionId] = useState("0");
  const [deletedDataSet, setDeletedDataSet] = useState([]);
  const [isPositive, setIsPositive] = useState(true);
  const [pickListMethod, setPickListMethod] = useState();
  const [renderAfterPost, setRenderAfterPost] = useState(false);

  const [generatedInvoiceNo, setGeneratedInvoiceNo] = useState("");
  const [bFirst, setBFirst] = useState(true);

  const saveInFlightRef = useRef(false);

  const handleRDateChange = (date, field) => {
    let newDate;
    if (date == null) {
      newDate = date;
    } else {
      newDate = format(new Date(date), 'yyyy-MM-dd');
    }
    setFormData({ ...formData, [field]: newDate });
    setErrorObject({ ...errorObject, [field]: null });
  };

  const [errorObject, setErrorObject] = useState({});
  const { id } = useParams();
  const queryClient = useQueryClient();

  const { data, refetch } = useQuery(
    ["receive", id],
    () =>
      api.getAdjustmentInv(id).then((res) => {
        //This is for user has VIEW/EDIT permission in this page start
        if (props.permissionType === 1) {
          //when permissionType then it is only VIEW permission otherwise normal permission
          res.data.bStockUpdated = 1;
        }
        //This is for user has VIEW/EDIT permission in this page end

        setTransactionId(id);
        setFormData(res.data);
        setbStockUpdate(res.data.bStockUpdated);
        setManyTableData(res.data.ManyJsonSave); //res.data.ManyJsonSave
        setUpdatedDetailGridData(res.data.ManyJsonSave);
        setGeneratedInvoiceNo(res.data.TransactionNo);
        let IsPositive = res.data.IsPositive == "-1" ? true : false;
        setIsPositive(IsPositive);
        setPickListMethod(res.data.PickListMethod);
        setBFirst(true);
        return res.data;
      }),
    {
      refetchOnWindowFocus: false,
      enabled: Boolean(id),
    }
  );

  const { isLoading: isUpdateMutating, mutate: mutateUpdate } = useMutation(
    api.updateAdjustmentInv,
    {
      onSuccess: (data) => {
        if (data.status == 200) {
          if (data.bStockUpdated == 1) {
            mutatePost(TransactionId);
          } else {
            refetch();
            setDeletedDataSet([]);

            props.openNoticeModal({
              isOpen: true,
              msg: data.message,
              msgtype: data.success,
            });
          }
        } else {
          props.openNoticeModal({
            isOpen: true,
            msg: data.message,
            msgtype: data.success,
          });
        }
      },
    }
  );

  const { isLoading: isPostMutating, mutate: mutatePost } = useMutation(
    api.updateAdjStock,
    {
    onSuccess: (data) => {
      if (data.status == 200) {
        setbStockUpdate(data.bStockUpdated);
        setDeletedDataSet([]);

        if (data.success == 0) {
          props.openNoticeModal({
            isOpen: true,
            msg: data.message,
            msgtype: data.success,
          });
        } else {
          refetch();
          props.openNoticeModal({
            isOpen: true,
            msg: data.message,
            msgtype: data.success,
            duration: 10000,
          });
        }
      }else if (data.success == 0) {
        props.openNoticeModal({
          isOpen: true,
          msg: data.message,
          msgtype: data.success,
        });
      }
    },
  }
  );

  const isSubmitting = isUpdateMutating || isPostMutating;

  const runAdjustmentUpdate = (payload) => {
    if (saveInFlightRef.current || isPostMutating) return;
    saveInFlightRef.current = true;
    mutateUpdate(payload, {
      onSettled: () => {
        saveInFlightRef.current = false;
      },
    });
  };

  const handleAdd = (NonOrderProductData) => {
    setManyTableData(NonOrderProductData);
    setUpdatedDetailGridData(NonOrderProductData);
  };
  const handleChange = (e) => {
    if (e == "IssuedToFacility") {
      setErrorObject({ ...errorObject, ["IssueToFacility"]: null });
    } else {
      const { name, value } = e.target;
      // if (name == "price" || name == "sellingPrice" || name == "markUp") {
      //   checkNumberValidation(name, value);
      // } else {
      let data = { ...formData };
      data[name] = value;
      // let productData = generateProductCodeAndName(data);
      // if (productData.productCode) {
      //   data["productCode"] = productData.productCode
      // }
      // if (productData.productName) {
      //   data["productName"] = productData.productName
      // }
      setFormData(data);
      // }
      setErrorObject({ ...errorObject, [name]: null });
    }
  };

  const handleCheck = (e) => {
    const { name, checked } = e.target;
    setFormData({ ...formData, [name]: checked });
  };

  const handleReset = () => {
    setFormData({
      TransactionDate: "",
      SupplierInvDate: "",
      SupplierInvNo: "",
      TransactionNo: "",
      FacilityId: FacilityId,
      TransactionId: "",
      PreparedBy: "",
      ApprovedBy: "",
      ItemGroupId: "",
    });
  };

  const validateForm = (formData) => {
    let validateFields = [
      "TransactionDate",
      "TransactionNo",
      "IssueToFacility",
      "PreparedBy",
      "PreparedBy",
    ];
    let errorData = {};
    let isValid = true;
    validateFields.map((field) => {
      if (!formData[field]) {
        errorData[field] =
          DispensingLanguage[lan][menukey]["field is Required !"];
        isValid = false;
      }
    });
    setErrorObject(errorData);
    return isValid;
  };

  const deleteAdjustmentInv = (data) => {
    let newarray = ManyTableData.filter((element) => element !== data);

    setManyTableData(newarray);
    setUpdatedDetailGridData(newarray);
    if (data.TransactionItemId != null) {
      let newDeletedDataSet = [data.TransactionItemId];
      setDeletedDataSet(newDeletedDataSet.concat(deletedDataSet));
    }
  };

  const handleUpdate = async (e) => {
    if (saveInFlightRef.current || isSubmitting) return;
    if (validateForm(formData)) {
      let fDtat = {
        ...formData,
        ManyJsonSave: ManyTableData,
        deletedDataSet: deletedDataSet,
      };
      runAdjustmentUpdate(fDtat);
    }
  };

  const handlePost = async (e) => {
    console.log("jasffff");
    if (saveInFlightRef.current || isSubmitting) return;
    if (validateForm(formData)) {
      // Start Post Alert
      swal({
        title: t(DispensingLanguage[lan][menukey]["Are you sure?"]),
        text: t(
          DispensingLanguage[lan][menukey][
            "Do you really want to post the stock?"
          ]
        ),
        icon: "warning",
        buttons: [
          t(DispensingLanguage[lan][menukey]["No"]),
          t(DispensingLanguage[lan][menukey]["Yes"]),
        ],
        dangerMode: true,
      }).then((willAction) => {
        if (willAction) {
          //setStockPost(true);
          if (saveInFlightRef.current || isSubmitting) return;
          let fDtat = {
            ...formData,
            ManyJsonSave: ManyTableData,
            bStockUpdated: 1,
            deletedDataSet: deletedDataSet,
          };
          runAdjustmentUpdate(fDtat);
        } else {
          console.log("Cancel");
          setbStockUpdate(0);
          let route = `${TransactionId}`;
          props.history.push(route);
        }
      });
      // End Post Alert
    }
  };

  const setUpdatedDetailsGridDataHandler = (rows) => {
    if (rows.datatype == "FormData") {
      setFormData(rows.IssueToFacility);
    } else {
      if (saveInFlightRef.current || isSubmitting) return;
      if (validateForm(formData)) {
        let fDtat = {
          ...formData,
          ManyJsonSave: rows.data,
          menukey: "adjustment",
          deletedDataSet: deletedDataSet,
        };
        runAdjustmentUpdate(fDtat);
      }
      setManyTableData(rows.data);
    }

    /*
    if (validateForm(formData)) {
      let fDtat={...formData,'ManyJsonSave':rows,'deletedDataSet':deletedDataSet}; 
      mutateUpdate(fDtat); 
      }

    // const updateManyTableData = ManyTableData.map((row) => {
    //   if (row.SKU == rows.SKU) {
    //     row.Quantity = rows.Quantity;
    //     row.BatchNo = rows.BatchNo;
    //     row.ExpiryDate = rows.ExpiryDate;
    //   }
      
    //   return row;
    // });
    setManyTableData(rows); 

  */
  };

  const updateIspositive = (isPosVal) => {
    setIsPositive(isPosVal);
  };
  useEffect(() => {}, [isPositive, pickListMethod, deletedDataSet]);

  return (
    <>
      <AdjustmentFormData
        errorObject={errorObject}
        addProductForm={false}
        formData={formData}
        handleChange={handleChange}
        handleCheck={handleCheck}
        handleReset={handleReset}
        handleUpdate={handleUpdate}
        ManyTableData={updatedDetailGridData}
        handleRDateChange={handleRDateChange}
        selectedDate={selectedDate}
        handleAdd={handleAdd}
        bStockUpdate={bStockUpdate}
        setUpdatedDetailsGridDataHandler={setUpdatedDetailsGridDataHandler}
        handlePost={handlePost}
        deleteAdjustmentInv={deleteAdjustmentInv}
        generatedInvoiceNo={generatedInvoiceNo}
        DisableAddBtn={false}
        isPositive={isPositive}
        updateIspositive={updateIspositive}
        pickListMethod={pickListMethod}
        bFirst={bFirst}
        {...props}
        isSubmitting={isSubmitting}
      />
    </>
  );
};

export default EditAdjustment;
